import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaoradpesquisaprefaturaunidata(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaoradpesquisaprefaturaunidata/FIND_RADPESQUISAPREFATURAUNIDATA':
      case '@operacaoradpesquisaprefaturaunidata/UPDATE_RADPESQUISAPREFATURAUNIDATA':
      case '@operacaoradpesquisaprefaturaunidata/DELETE_RADPESQUISAPREFATURAUNIDATA':
      case '@operacaoradpesquisaprefaturaunidata/STORE_RADPESQUISAPREFATURAUNIDATA':
      case '@operacaoradpesquisaprefaturaunidata/RADPESQUISAPREFATURAUNIDATA_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacaoradpesquisaprefaturaunidata/SUCCESS_REMOVE':
      case '@operacaoradpesquisaprefaturaunidata/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaoradpesquisaprefaturaunidata/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaoradpesquisaprefaturaunidata;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaoradpesquisaprefaturaunidata/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaoradpesquisaprefaturaunidata;
        break;
      }

      case '@operacaoradpesquisaprefaturaunidata/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
